import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../hooks/useAppReducer';
import useLocalStorage from '../hooks/useLocalStorage';
import CONSTANT from '../constant';

interface IPrivateRoute {
    children: any;
    allowedRoles: number[];
}

const PrivateRoute: React.FC<IPrivateRoute> = ({ children, allowedRoles }) => {
    const { isLoggedIn } = useAppSelector((state) => state.authReducer);
    const location = useLocation();

    // const userProfile = useLocalStorage.get(CONSTANT.APP.USER_PROFILE);

    const userProfile = useMemo(() => {
        return useLocalStorage.get(CONSTANT.APP.USER_PROFILE);
    }, []);

    if (!isLoggedIn) {
        return <Navigate to="/auth/login" state={{ from: location }} replace />;
    }

    if (allowedRoles && (!userProfile || !allowedRoles.includes(userProfile.role_id))) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PrivateRoute;
